import React from 'react';
import { UserPlus, Archive, Trash2 } from 'lucide-react';

interface BrandActionsMenuProps {
  brandId: string;
  isGlobalDarkMode: boolean;
  openMenuId: string | null;
  setOpenMenuId: (id: string | null) => void;
  handleDelete: (id: string) => void;
  handleAssignTeamMember: (id: string) => void;
  handleArchive?: (id: string) => void;
}

export const BrandActionsMenu: React.FC<BrandActionsMenuProps> = ({
  brandId,
  isGlobalDarkMode,
  openMenuId,
  setOpenMenuId,
  handleDelete,
  handleAssignTeamMember,
  handleArchive
}) => {
  return (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleAssignTeamMember(brandId);
          setOpenMenuId(null);
        }}
        className="w-full px-3 py-2 text-left text-sm transition-colors flex items-center gap-2 text-foreground hover:bg-accent rounded-lg"
      >
        <UserPlus className="w-4 h-4" />
        <span>Assign</span>
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleArchive?.(brandId);
          setOpenMenuId(null);
        }}
        className="w-full px-3 py-2 text-left text-sm transition-colors flex items-center gap-2 text-foreground hover:bg-accent rounded-lg"
      >
        <Archive className="w-4 h-4" />
        <span>Archive</span>
      </button>

      <div className="my-1 h-px bg-border" />

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleDelete(brandId);
          setOpenMenuId(null);
        }}
        className="w-full px-3 py-2 text-left text-sm transition-colors flex items-center gap-2 text-destructive hover:bg-destructive/10 rounded-lg"
      >
        <Trash2 className="w-4 h-4" />
        <span>Delete</span>
      </button>
    </>
  );
};
